<template>
    <Wp_jd_select_for_member
            :position_id="position_id"
            :keyword="keyword"
    ></Wp_jd_select_for_member>
</template>

<script>
    import Wp_jd_select_for_member from "./Wp_jd_select_for_member";
    export default {
        name: "Wp_group_member_app",
        components: {Wp_jd_select_for_member},
        props:{
            position_id:{
                type:String,
                default:''
            },
            keyword:{
                type:String,
                default:''
            }
        },
        created() {
            if (document.getElementById('loading')) {
                document.body.removeChild(document.getElementById('loading'));
            }
        }
    }
</script>

<style scoped>

</style>